import React, { useState, useEffect, useRef } from "react";
import { Tab, Tabs, Form, Button, Modal, Row, Col } from "react-bootstrap";
import Profile from "../../assets/images/couple-default.png";
import corruptedImg from "../../assets/images/corrupted-img.png";
import PhoneInput from "../../components/PhoneInput";
import CopyableInput from "../../components/CopyableInput";
import DatePicker from "../../components/AppDatePicker";
import AdminApi from "../../api/admin";
import AuthApi from "../../api/authApi";
import moment from "moment";
import { toast } from "react-toastify";
import OtherParishModal from "../../components/OtherParishModal";
import { formatParishOptionLabel } from "../../utils/parishLabels";
import { Heart, MapPin, Megaphone, Phone, Users, X } from "lucide-react";
import RetreatPhotoPicker from "../../components/RetreatPhotoPicker";
import "../../assets/css/coupleFormModal.css";
// import axios from "axios";

const UpdateCouplePopUp = ({
  showRegModal,
  onHide,
  closeButton,
  data,
  isEditAdmin,
  parishList,
  setParishList,
  ediUserIdClicked,
  CloseCompose,
  roasterCount,
  userData,
  roastersOfCoupleList,
  refreshRoastersOfCouple = null,
  coupleOldValues,
  setShowREgModal,
  setEdiUserIdClicked,
  getAllCouples,
  setData,
  oldValues,
  setOldValues,
  isTempUpload,
  isTempUpload2,
  setIsTempUpload,
  retreatDetail = null,
  onSuccess = null,
  // setIsTempUpload2,
}) => {
  const [validated, setValidated] = useState(false);
  const [oldData, setOldData] = useState([]);
  const [otherParishModalOpen, setOtherParishModalOpen] = useState(false);
  const [couplePhotoUrl, setCouplePhotoUrl] = useState("");
  const [changingRosterId, setChangingRosterId] = useState(null);
  const couplePhotoBaseline = useRef({ id: "", url: "" });
  const couplePhotoFile = useRef(null);
  let adminApi = new AdminApi();
  const [emailErrors, setEmailErrors] = useState({
    hisEmail: "",
    herEmail: "",
  });

  const handleChangeRetreatPhoto = async ({ file, rosterId, coupleId }) => {
    if (!file || !rosterId) return;
    const fileNameOf = (url) => {
      if (!url || url === "null") return "";
      return String(url).split("?")[0].split("/").pop();
    };
    const currentRow = (Array.isArray(roastersOfCoupleList)
      ? roastersOfCoupleList
      : []
    ).find((row) => String(row?.rosterId) === String(rosterId));
    const previousUrl =
      currentRow?.roasterImage || currentRow?.imageUrl || "";
    const formData = new FormData();
    formData.append("file", file);
    formData.append("rosterId", rosterId);
    formData.append("coupleId", coupleId || ediUserIdClicked || data?.id || "");
    formData.append("skipCoupleFill", "true");
    setChangingRosterId(rosterId);
    try {
      const res = await adminApi.saveCoupleImage(formData);
      if (res?.success) {
        toast.success("Retreat Picture updated.");
        const nextUrl = res.imageUrl || "";
        if (
          nextUrl &&
          typeof data?.imageUrl === "string" &&
          previousUrl &&
          fileNameOf(data.imageUrl) === fileNameOf(previousUrl)
        ) {
          setIsTempUpload(false);
          setData({ ...data, imageUrl: nextUrl });
        }
        if (typeof refreshRoastersOfCouple === "function") {
          await refreshRoastersOfCouple(
            coupleId || ediUserIdClicked || data?.id,
          );
        }
      } else {
        toast.error(res?.msg || "Could not update Retreat Picture.");
      }
    } catch (error) {
      toast.error(error?.toString?.() || "Could not update Retreat Picture.");
    } finally {
      setChangingRosterId(null);
    }
  };

  useEffect(() => {
    if (!ediUserIdClicked) {
      couplePhotoBaseline.current = { id: "", url: "" };
      couplePhotoFile.current = null;
      setCouplePhotoUrl("");
      return;
    }
    const saved =
      data?.lastCoupleImage && data.lastCoupleImage !== "null"
        ? data.lastCoupleImage
        : "";
    const current =
      typeof data?.imageUrl === "string" &&
      data.imageUrl &&
      data.imageUrl !== "null"
        ? data.imageUrl
        : "";
    const nextUrl = saved || current || "";
    if (couplePhotoBaseline.current.id !== ediUserIdClicked && nextUrl) {
      couplePhotoBaseline.current = { id: ediUserIdClicked, url: nextUrl };
      couplePhotoFile.current = null;
      setCouplePhotoUrl(nextUrl);
    } else if (
      couplePhotoBaseline.current.id === ediUserIdClicked &&
      saved &&
      couplePhotoBaseline.current.url !== saved &&
      !String(couplePhotoBaseline.current.url).startsWith("blob:")
    ) {
      couplePhotoBaseline.current = { id: ediUserIdClicked, url: saved };
      setCouplePhotoUrl(saved);
    }
  }, [ediUserIdClicked, data?.id, data?.lastCoupleImage]);
  // const [suggestions, setSuggestions] = useState([]);
  // useEffect(() => {
  //   if (coupleData && coupleOldValues) {
  //     setData(coupleData);
  //     setOldValues(coupleOldValues);
  //   } else {
  //     authApi
  //       .checkPKCouple()
  //       .then((res) => {
  //         if (res.success) {
  //           if (res.data != null) {
  //             let incPK = res.data + 1;
  //             setAlreadyPk(incPK);
  //             let d = { ...data };
  //             d.primaryKey = incPK;
  //             setData(d);
  //           } else {
  //             let defaultPK = 1001;
  //             setAlreadyPk(defaultPK);
  //             let d = { ...data };
  //             d.primaryKey = defaultPK;
  //             setData(d);
  //           }
  //         } else {
  //           toast.error(res.msg);
  //         }
  //       })
  //       .catch((error) => {
  //         toast.error(error);
  //       });
  //   }
  //   // if (!coupleData.id) {
  //   //   checkPKCouple();
  //   // }
  // }, [coupleData]);

  // const handleSearch = async (e) => {
  //   const value = e.target.value;
  //   handleChanges(e); // keep your original logic

  //   if (value.length > 2) {
  //     try {
  //       const res = await axios.get(
  //         `https://nominatim.openstreetmap.org/search?format=json&q=${value}`
  //       );
  //       setSuggestions(res.data);
  //     } catch (error) {
  //       console.error("Error fetching address suggestions:", error);
  //     }
  //   } else {
  //     setSuggestions([]);
  //   }
  // };

  // const handleSelect = (address) => {
  //   handleChanges({
  //     target: { name: "address", value: address.display_name },
  //   });
  //   setSuggestions([]);
  // };

  const upload = () => {
    document.getElementById("CoupleProfileUpload").click();
  };

  // const uploadMarriagePhoto = () => {
  //   document.getElementById("MarriagePhotoUpload").click();
  //   setIsTempUpload2(true);
  // };

  const remove = () => {
    let d = { ...data };
    d.imageUrl = "";
    setData(d);
    setIsTempUpload(false);
  };

  const handleDatePicker = (e) => {
    let o = { ...data };
    o.anniversary_date = e;
    setData(o);
  };

  const handleAgeChanges = (e) => {
    const { name, checked } = e.target;
    let o = { ...data };
    o.under_age_35 = checked ? "YES" : "NO";
    setData(o);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    let hearUsArray = Array.isArray(data.hear_us)
      ? data.hear_us
      : JSON.parse(data.hear_us);
    let updatedOptions;
    if (checked) {
      updatedOptions = hearUsArray ? [...hearUsArray, name] : [name];
    } else {
      updatedOptions = hearUsArray.filter((option) => option !== name);
    }
    setData({ ...data, hear_us: updatedOptions });
  };

  const handleChanges = (e) => {
    let { name, value } = e.target;
    let d = { ...data };
    let o = { ...oldData };
    if (name === "hisFirstName") {
      o.hisFirstName = oldValues.hisFirstName;
    } else if (name === "hisLastName") {
      o.hisLastName = oldValues.hisLastName;
    } else if (name === "hisEmail") {
      o.hisEmail = oldValues.hisEmail;
    } else if (name === "hisMobile") {
      o.hisMobile = oldValues.hisMobile;
    } else if (name === "herFirstName") {
      o.herFirstName = oldValues.herFirstName;
    } else if (name === "herLastName") {
      o.herLastName = oldValues.herLastName;
    } else if (name === "herEmail") {
      o.herEmail = oldValues.herEmail;
    } else if (name === "herMobile") {
      o.herMobile = oldValues.herMobile;
    } else if (name === "parishId") {
      if (value === "OTHER") {
        setOtherParishModalOpen(true);
      }
      if (value === "") {
        value = retreatDetail?.parishId || "";
      }
      d.parishId = value;
      o.parishId = oldValues.parishId;
    } else if (name === "notes") {
      o.notes = oldValues.notes;
    } else if (name === "zip") {
      o.zip = oldValues.zip;
    } else if (name === "city") {
      o.city = oldValues.city;
    } else if (name === "address") {
      o.address = oldValues.address;
    } else if (name === "allergies") {
      o.allergies = oldValues.allergies;
    } else if (name === "anniversary_date") {
      o.anniversary_date = oldValues.anniversary_date;
    } else if (name === "state") {
      o.state = oldValues.state;
    } else if (name === "imageUrl") {
      o.imageUrl = oldValues.imageUrl;
    } else if (name === "under_age_35") {
      o.under_age_35 = oldValues.under_age_35;
    } else if (name === "emergency_name1") {
      o.emergency_name1 = oldValues.emergency_name1;
    } else if (name === "emergency_relationship1") {
      o.emergency_relationship1 = oldValues.emergency_relationship1;
    } else if (name === "emergency_phone1") {
      o.emergency_phone1 = oldValues.emergency_phone1;
    } else if (name === "emergency_name2") {
      o.emergency_name1 = oldValues.emergency_name1;
    } else if (name === "emergency_relationship2") {
      o.emergency_relationship1 = oldValues.emergency_relationship1;
    } else if (name === "emergency_phone2") {
      o.emergency_phone1 = oldValues.emergency_phone1;
    } else if (name === "hear_us") {
      o.hear_us = oldValues.hear_us;
    } else if (name === "referral_from_a_friend_or_family_member") {
      o.referral_from_a_friend_or_family_member =
        oldValues.referral_from_a_friend_or_family_member;
    }
    setOldData(o);

    // ONLY FOR UPLOAD COUPLE IMAGE
    if (name === "imageUrl") {
      const file = e.target.files[0];
      if (file) {
        const fileSizeInMB = file.size / (1024 * 1024); // Convert size from bytes to MB
        if (fileSizeInMB > 3) {
          alert("File size should be less than 3 MB");
          return;
        } else {
          d[name] = file;
          setIsTempUpload(true);
          const previewUrl = URL.createObjectURL(file);
          couplePhotoFile.current = file;
          setCouplePhotoUrl(previewUrl);
          couplePhotoBaseline.current = {
            id: ediUserIdClicked || data?.id || "",
            url: previewUrl,
          };
          const successMessage =
            name === "imageUrl"
              ? "The profile image has been successfully added."
              : "";
          toast.success(successMessage);
        }
      }
    } else {
      d[name] = value;
    }
    setData(d);

    if (name === "hisEmail" || name === "herEmail") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        setEmailErrors((prev) => ({ ...prev, [name]: "Invalid email format" }));
      } else {
        setEmailErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (emailErrors.hisEmail || emailErrors.herEmail) {
      toast.error("Please enter valid email addresses.");
      return;
    }

    if (form.checkValidity()) {
      if (
        ediUserIdClicked &&
        ediUserIdClicked !== "" &&
        ediUserIdClicked !== null
      ) {
        let data1 = new FormData();
        const isFileUpload = data.imageUrl instanceof File;
        if (isFileUpload) {
          data1.append("file", data.imageUrl);
        }
        let stateRef = { ...data };
        if (isFileUpload) {
          delete stateRef.imageUrl;
        }
        if (stateRef.parishId === "" || stateRef.parishId === null) {
          stateRef.parishId = retreatDetail.parishId || "";
        }
        data1.append("fromData", JSON.stringify(stateRef));
        adminApi
          .editCouple(data1)
          .then(async (res) => {
            if (res.success) {
              toast.success(res.msg);
              getAllCouples && getAllCouples();
              CloseCompose && CloseCompose();
              clearfield();
              setData({
                id: "",
                hisFirstName: "",
                hisLastName: "",
                hisEmail: "",
                hisMobile: "",
                herFirstName: "",
                herLastName: "",
                herEmail: "",
                herMobile: "",
                city: "",
                state: "",
                zip: "",
                notes: "",
                imageUrl: "",
                lastCoupleImage: "",
                parishId: null,
                address: "",
                allergies: "",
                anniversary_date: "",
                under_age_35: "NO",
                emergency_name1: "",
                emergency_relationship1: "",
                emergency_phone1: "",
                emergency_name2: "",
                emergency_relationship2: "",
                emergency_phone2: "",
                hear_us: [],
                referral_from_a_friend_or_family_member: "",
              });
              setOldData([]);
              setShowREgModal(false);
              setEdiUserIdClicked("");
              getAllCouples();
              if (onSuccess) {
                onSuccess(res.data);
              }
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        let data1 = new FormData();
        const isFileUpload = data.imageUrl instanceof File;
        if (isFileUpload) {
          data1.append("file", data.imageUrl);
        }
        let stateRef = { ...data };
        if (stateRef?.parishId === "" || stateRef?.parishId === null) {
          stateRef.parishId = retreatDetail?.parishId || "";
        }
        delete stateRef.imageUrl;
        data1.append("fromData", JSON.stringify(stateRef));
        adminApi
          .createCouple(data1)
          .then(async (res) => {
            if (res.success) {
              toast.success(res.msg);
              clearfield();
              setEdiUserIdClicked("");
              setShowREgModal(false);
              getAllCouples();
              if (onSuccess) {
                onSuccess(res.data);
              }
              remove();
              setData({
                id: "",
                hisFirstName: "",
                hisLastName: "",
                hisEmail: "",
                hisMobile: "",
                herFirstName: "",
                herLastName: "",
                herEmail: "",
                herMobile: "",
                city: "",
                state: "",
                zip: "",
                notes: "",
                imageUrl: "",
                lastCoupleImage: "",
                address: "",
                allergies: "",
                anniversary_date: "",
                under_age_35: "NO",
                emergency_name1: "",
                emergency_relationship1: "",
                emergency_phone1: "",
                emergency_name2: "",
                emergency_relationship2: "",
                emergency_phone2: "",
                hear_us: [],
                referral_from_a_friend_or_family_member: "",
              });
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
    setValidated(true);
  };

  const clearfield = () => {
    setData({
      id: "",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      hisMobile: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
      herMobile: "",
      city: "",
      state: "",
      zip: "",
      notes: "",
      imageUrl: "",
      lastCoupleImage: "",
      parishId: null,
      address: "",
      allergies: "",
      anniversary_date: "",
      under_age_35: "NO",
      emergency_name1: "",
      emergency_relationship1: "",
      emergency_phone1: "",
      emergency_name2: "",
      emergency_relationship2: "",
      emergency_phone2: "",
      hear_us: [],
      referral_from_a_friend_or_family_member: "",
    });
    couplePhotoBaseline.current = { id: "", url: "" };
    couplePhotoFile.current = null;
    setCouplePhotoUrl("");
    setValidated(false);
  };

  const hasCouplePhoto = data?.imageUrl !== "" && data?.imageUrl != undefined;
  const coupleNames = [
    [data?.hisFirstName, data?.hisLastName].filter(Boolean).join(" "),
    [data?.herFirstName, data?.herLastName].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(" & ");
  const editingCouple = Boolean(ediUserIdClicked && ediUserIdClicked !== "");
  const hasRetreatPhotos = (Array.isArray(roastersOfCoupleList)
    ? roastersOfCoupleList
    : []
  ).some((row) => {
    const url = row?.roasterImage || row?.imageUrl || "";
    return url && url !== "null";
  });

  const renderCoupleRetreats = () => {
    const retreatRows = Array.isArray(roastersOfCoupleList)
      ? roastersOfCoupleList
      : [];
    const retreatLabel = (row) => {
      const language = row?.language
        ? ` (${String(row.language).charAt(0).toUpperCase()}${String(row.language).slice(1)})`
        : "";
      const location = row?.location
        ? ` ${String(row.location).charAt(0).toUpperCase()}${String(row.location).slice(1)}`
        : "";
      return `${row?.parish || "Retreat"}${language}${location}`.trim();
    };
    const retreatDates = (row) => {
      if (!row?.dateFrom) return "";
      if (row.dateFrom === row.dateTo) {
        return moment(row.dateFrom).format("MMM DD, YYYY");
      }
      return `${moment(row.dateFrom).format("MMM DD")} – ${moment(row.dateTo).format("MMM DD, YYYY")}`;
    };

    return (
      <div className="rr-couple-retreats">
        <div className="rr-couple-retreats-count">
          <div>
            <span>Retreats Attended</span>
            <p>Retreats this couple has joined, with their role on each one.</p>
          </div>
          <strong>{roasterCount || retreatRows.length}</strong>
        </div>
        {retreatRows.length === 0 ? (
          <div className="rr-couple-retreats-empty">
            This couple is not on a retreat roster yet.
          </div>
        ) : (
          <ul className="rr-couple-retreat-list">
            {retreatRows.map((row, index) => {
              const title = retreatLabel(row);
              const dates = retreatDates(row);
              const linked = !(userData && userData.userRole === "SUBADMIN");
              return (
                <li
                  className="rr-couple-retreat-card"
                  key={`${row.id || "retreat"}-${index}`}
                >
                  <div className="rr-couple-retreat-main">
                    {linked ? (
                      <a
                        href={`/retreatRoster?retreatId=${row.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {title}
                      </a>
                    ) : (
                      <strong>{title}</strong>
                    )}
                    {dates ? <span>{dates}</span> : null}
                  </div>
                  <dl className="rr-couple-retreat-meta">
                    <div>
                      <dt>Type</dt>
                      <dd>
                        {row?.attendeeType === "Team" ? (
                          <span className="rr-couple-type rr-couple-type--team">
                            {row.attendeeType}
                          </span>
                        ) : row?.attendeeType ? (
                          <span className="rr-couple-type">{row.attendeeType}</span>
                        ) : (
                          <span className="rr-couple-empty-cell">—</span>
                        )}
                      </dd>
                    </div>
                    <div>
                      <dt>Role</dt>
                      <dd className={row?.role ? "" : "is-empty"}>
                        {row?.role || "—"}
                      </dd>
                    </div>
                    <div>
                      <dt>Service</dt>
                      <dd className={row?.service ? "" : "is-empty"}>
                        {row?.service || "—"}
                      </dd>
                    </div>
                    <div>
                      <dt>Talk</dt>
                      <dd className={row?.talk ? "" : "is-empty"}>
                        {row?.talk || "—"}
                      </dd>
                    </div>
                  </dl>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  };

  return (
    <>
      <Modal
        show={showRegModal}
        onHide={onHide}
        centered
        enforceFocus={false}
        className="rr-couple-modal"
        dialogClassName="rr-couple-dialog"
        contentClassName="rr-couple-content"
        aria-labelledby="rr-couple-modal-title"
      >
        <div className="rr-couple-shell">
          <header className="rr-couple-header">
            <div className="rr-couple-mark" aria-hidden="true">
              <Users size={20} />
            </div>
            <div className="rr-couple-header-copy">
              <p className="rr-couple-kicker">Couple record</p>
              <h2 id="rr-couple-modal-title">
                {editingCouple ? "Edit Couple" : "Add a Couple"}
              </h2>
              <p>
                {coupleNames ||
                  "Names, contact details, and the retreats this couple has joined."}
              </p>
            </div>
            <button
              type="button"
              className="rr-couple-close"
              onClick={onHide}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </header>
          <div className="rr-couple-edit">
        <Tabs
          defaultActiveKey="Couple Details"
          id="rr-couple-edit-tabs"
          className="rr-couple-tabs"
        >
          <Tab eventKey="Couple Details" title="Couple Details">
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
              className="forms-sample rr-couple-form"
            >
              <Modal.Body className="rr-couple-body">
                <div className="rr-couple-fields">
                <section className="rr-couple-section rr-couple-identity">
                  <div className="rr-couple-identity-main">
                    <Form.Group className="rr-couple-id">
                      <Form.Label htmlFor="primaryKey">Couple ID</Form.Label>
                      <Form.Control
                        required
                        size="sm"
                        type="text"
                        name="primaryKey"
                        id="primaryKey"
                        placeholder="Couple Id"
                        value={data.primaryKey ?? ""}
                        className="form-control"
                        onChange={(e) => handleChanges(e)}
                        readOnly
                      />
                      <span className="rr-couple-hint">
                        Assigned automatically. This id is used across retreats.
                      </span>
                      <Form.Control.Feedback type="invalid">
                        Couple Id is required!
                      </Form.Control.Feedback>
                    </Form.Group>
                    <label className="rr-couple-age" htmlFor="under_age_35">
                      <input
                        id="under_age_35"
                        type="checkbox"
                        name="under_age_35"
                        checked={data.under_age_35 === "YES"}
                        onChange={handleAgeChanges}
                      />
                      <span>
                        <strong>35 or younger</strong>
                        <small>
                          Check this if either spouse is 35 years of age or younger.
                        </small>
                      </span>
                    </label>
                  </div>
                  <div className="rr-couple-photo-panel">
                    <div className="rr-couple-photo-panel-head">
                      <span>Profile photo</span>
                      {editingCouple && hasRetreatPhotos ? (
                        <p>
                          Upload a new photo, or choose a Retreat photo for the
                          couple profile. Retreat Pictures stay unchanged.
                        </p>
                      ) : null}
                    </div>
                    <div className="rr-couple-photo-panel-body">
                      <div className="rr-couple-photo-wrap">
                        <div
                          className={`rr-couple-photo${
                            hasCouplePhoto ? "" : " is-empty"
                          }`}
                        >
                          {hasCouplePhoto ? (
                            <img
                              src={
                                data.imageUrl instanceof Blob
                                  ? URL.createObjectURL(data.imageUrl)
                                  : data.imageUrl
                              }
                              alt="Couple"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = corruptedImg;
                              }}
                            />
                          ) : (
                            <img src={Profile} alt="" />
                          )}
                          {hasCouplePhoto ? (
                            <em className="rr-couple-photo-badge">Current</em>
                          ) : null}
                        </div>
                        {userData && userData.userRole === "SUBADMIN" ? null : (
                          <div className="rr-couple-photo-actions">
                            <input
                              name="imageUrl"
                              type="file"
                              accept="image/*"
                              id="CoupleProfileUpload"
                              onChange={(e) => {
                                handleChanges(e);
                                e.target.value = "";
                              }}
                            />
                            <button
                              type="button"
                              className="rr-couple-photo-btn"
                              onClick={() => upload()}
                            >
                              {hasCouplePhoto ? "Change photo" : "Upload photo"}
                            </button>
                            {hasCouplePhoto ? (
                              <button
                                type="button"
                                className="rr-couple-photo-btn is-danger"
                                onClick={() => remove()}
                              >
                                Remove
                              </button>
                            ) : null}
                          </div>
                        )}
                      </div>
                      {editingCouple && hasRetreatPhotos ? (
                        <RetreatPhotoPicker
                          retreatRows={roastersOfCoupleList}
                          couplePhotoUrl={couplePhotoUrl}
                          coupleId={ediUserIdClicked || data?.id}
                          changingRosterId={changingRosterId}
                          onChangeRetreatPhoto={
                            userData && userData.userRole === "SUBADMIN"
                              ? null
                              : handleChangeRetreatPhoto
                          }
                          selectedUrl={
                            data?.imageUrl instanceof Blob
                              ? couplePhotoUrl
                              : data?.imageUrl
                          }
                          onSelect={(url) => {
                            if (
                              couplePhotoFile.current &&
                              url === couplePhotoUrl
                            ) {
                              setIsTempUpload(true);
                              setData({
                                ...data,
                                imageUrl: couplePhotoFile.current,
                              });
                              return;
                            }
                            setIsTempUpload(false);
                            setData({ ...data, imageUrl: url });
                          }}
                          disabled={
                            userData && userData.userRole === "SUBADMIN"
                          }
                        />
                      ) : null}
                    </div>
                  </div>
                </section>

                <section className="rr-couple-section">
                  <div className="rr-couple-section-head">
                    <span className="rr-couple-section-icon" aria-hidden="true">
                      <Heart size={16} />
                    </span>
                    <div>
                      <h3>Couple</h3>
                      <p>Names, email, and phone for each spouse.</p>
                    </div>
                  </div>
                <Row className="rr-couple-people">
                  <Col lg={6} md={6} xs={12}>
                    <div className="rr-couple-person rr-couple-person--his">
                      <div className="rr-couple-person-title">His information</div>
                    <div id="his-info">
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={
                              data.hisFirstName ? null : "highlightField mt-2"
                            }
                          >
                            First Name <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="hisFirstName"
                            id="hisFirstName"
                            placeholder="First Name"
                            value={data.hisFirstName}
                            className="form-control"
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            FirstName is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={
                              data.hisLastName ? null : "highlightField"
                            }
                          >
                            Last Name{" "}
                          </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="hisLastName"
                            id="hisLastName"
                            placeholder="Last Name"
                            value={data.hisLastName}
                            className="form-control"
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            LastName is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group col">
                          <Form.Label
                            className={data.hisEmail ? null : "highlightField"}
                          >
                            His Email <span className="text-danger">*</span>
                          </Form.Label>
                          <CopyableInput
                            // required
                            size="sm"
                            type="text"
                            name="hisEmail"
                            id="hisEmail"
                            placeholder="Email"
                            value={data.hisEmail}
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          {emailErrors.hisEmail && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.hisEmail}
                            </span>
                          )}
                          <Form.Control.Feedback type="invalid">
                            Email is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group col">
                          <Form.Label
                            className={data.hisMobile ? null : "highlightField"}
                          >
                            His Mobile (Ex- xxx-xxx-xxxx)
                          </Form.Label>
                          <PhoneInput
                            name="hisMobile"
                            value={data.hisMobile}
                            onChange={(e) => handleChanges(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            Mobile is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </div>
                    </div>
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <div className="rr-couple-person rr-couple-person--her">
                      <div className="rr-couple-person-title">Her information</div>
                    <div id="her-info">
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={
                              data.herFirstName ? null : "highlightField mt-2"
                            }
                          >
                            First Name <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="herFirstName"
                            id="herFirstName"
                            placeholder="First Name"
                            value={data.herFirstName}
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            FirstName is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={
                              data.herLastName ? null : "highlightField"
                            }
                          >
                            Last Name
                          </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="herLastName"
                            id="herLastName"
                            placeholder="Last Name"
                            value={data.herLastName}
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            LastName is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={data.herEmail ? null : "highlightField"}
                          >
                            Her Email <span className="text-danger">*</span>
                          </Form.Label>
                          <CopyableInput
                            size="sm"
                            type="text"
                            name="herEmail"
                            id="herEmail"
                            placeholder="Email"
                            value={data.herEmail}
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          {emailErrors.herEmail && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.herEmail}
                            </span>
                          )}
                          <Form.Control.Feedback type="invalid">
                            Email is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={data.herMobile ? null : "highlightField"}
                          >
                            Her Mobile (Ex- xxx-xxx-xxxx)
                          </Form.Label>
                          <PhoneInput
                            name="herMobile"
                            value={data.herMobile}
                            onChange={(e) => handleChanges(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            Mobile is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </div>
                    </div>
                  </Col>
                </Row>
                </section>

                <section className="rr-couple-section">
                  <div className="rr-couple-section-head">
                    <span className="rr-couple-section-icon" aria-hidden="true">
                      <MapPin size={16} />
                    </span>
                    <div>
                      <h3>Home</h3>
                      <p>
                        Address, parish, anniversary, and anything the team should
                        know.
                      </p>
                    </div>
                  </div>
                <div className="row">
                  {/* <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 position-relative">
                    <Form.Label
                      className={data.address ? null : "highlightField"}
                    >
                      Address
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="address"
                      id="address"
                      placeholder="Search address"
                      value={data.address}
                      onChange={handleSearch}
                      autoComplete="off"
                    />
                    <Form.Control.Feedback type="invalid">
                      Address is required!
                    </Form.Control.Feedback>
                    {suggestions.length > 0 && (
                      <ul
                        className="list-group position-absolute w-100 mt-1"
                        style={{
                          zIndex: 1000,
                          maxHeight: "200px",
                          overflowY: "auto",
                        }}
                      >
                        {suggestions.map((address) => (
                          <li
                            key={address.place_id}
                            onClick={() => handleSelect(address)}
                            className="list-group-item list-group-item-action"
                            style={{ cursor: "pointer" }}
                          >
                            {address.display_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </Form.Group> */}

                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label
                      className={data.address ? null : "highlightField"}
                    >
                      Address
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="address"
                      id="address"
                      placeholder="Address"
                      value={data.address}
                      onChange={(e) => handleChanges(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Address is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label
                      className={data.state ? null : "highlightField"}
                    >
                      State
                    </Form.Label>
                    <Form.Select
                      className="form-control minimal"
                      size="sm"
                      type="text"
                      name="state"
                      id="state"
                      placeholder="State"
                      value={data.state}
                      onChange={(e) => handleChanges(e)}
                    >
                      <option value="">Select State</option>
                      <option value="Alaska">Alaska</option>
                      <option value="Alabama">Alabama</option>
                      <option value="Arkansas">Arkansas</option>
                      <option value="Arizona">Arizona</option>
                      <option value="California">California</option>
                      <option value="Colorado">Colorado</option>
                      <option value="Connecticut">Connecticut</option>
                      <option value="District of Columbia">
                        District of Columbia
                      </option>
                      <option value="Delaware">Delaware</option>
                      <option value="Florida">Florida</option>
                      <option value="Georgia">Georgia</option>
                      <option value="Hawaii">Hawaii</option>
                      <option value="Iowa">Iowa</option>
                      <option value="Idaho">Idaho</option>
                      <option value="Illinois">Illinois</option>
                      <option value="Indiana">Indiana</option>
                      <option value="Kansas">Kansas</option>
                      <option value="Kentucky">Kentucky</option>
                      <option value="Louisiana">Louisiana</option>
                      <option value="Massachusetts">Massachusetts</option>
                      <option value="Maryland">Maryland</option>
                      <option value="Maine">Maine</option>
                      <option value="Michigan">Michigan</option>
                      <option value="Minnesota">Minnesota</option>
                      <option value="Missouri">Missouri</option>
                      <option value="Mississippi">Mississippi</option>
                      <option value="Montana">Montana</option>
                      <option value="North Carolina<">North Carolina</option>
                      <option value="North Dakota">North Dakota</option>
                      <option value="Nebraska">Nebraska</option>
                      <option value="New Hampshire">New Hampshire</option>
                      <option value="New Jersey">New Jersey</option>
                      <option value="New Mexico">New Mexico</option>
                      <option value="Nevada">Nevada</option>
                      <option value="New York">New York</option>
                      <option value="Ohio">Ohio</option>
                      <option value="Oklahoma">Oklahoma</option>
                      <option value="Oregon">Oregon</option>
                      <option value="Pennsylvania">Pennsylvania</option>
                      <option value="Puerto Rico">Puerto Rico</option>
                      <option value="Rhode Island">Rhode Island</option>
                      <option value="South Carolina">South Carolina</option>
                      <option value="South Dakota">South Dakota</option>
                      <option value="Tennessee">Tennessee</option>
                      <option value="Texas">Texas</option>
                      <option value="Utah">Utah</option>
                      <option value="Virginia">Virginia</option>
                      <option value="Vermont">Vermont</option>
                      <option value="Washington">Washington</option>
                      <option value="Wisconsin">Wisconsin</option>
                      <option value="West Virginia">West Virginia</option>
                      <option value="Wyoming">Wyoming</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      State is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label className={data.city ? null : "highlightField"}>
                      City
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="city"
                      id="city"
                      placeholder="City"
                      value={data.city}
                      onChange={(e) => handleChanges(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      City is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label className={data.zip ? null : "highlightField"}>
                      Zip
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="zip"
                      id="zip"
                      placeholder="Zip"
                      value={data.zip}
                      onChange={(e) => handleChanges(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Zip is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label
                      className={data.parishId ? null : "highlightField"}
                    >
                      Parish <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Group>
                      <Form.Select
                        required
                        size="sm"
                        name="parishId"
                        value={data.parishId || ""}
                        onChange={(e) => handleChanges(e)}
                      >
                        <option value="">NONE / NINGUNA</option>
                        <option value="OTHER">OTHER / OTRA</option>
                        <optgroup label="Select Parish">
                          {parishList
                            .filter(
                              (p) =>
                                p.parishCategoryName?.toUpperCase() !== "OTHER",
                            )
                            .map((p) => {
                              return (
                                <option key={p.id} value={p.id}>
                                  {formatParishOptionLabel(p)}
                                </option>
                              );
                            })}
                        </optgroup>
                        <optgroup label="OTHER">
                          {parishList
                            .filter(
                              (p) =>
                                p.parishCategoryName?.toUpperCase() === "OTHER",
                            )
                            .map((p) => {
                              return (
                                <option key={p.id} value={p.id}>
                                  {formatParishOptionLabel(p, {
                                    omitCategory: true,
                                  })}
                                </option>
                              );
                            })}
                        </optgroup>
                      </Form.Select>
                    </Form.Group>
                    <Form.Control.Feedback type="invalid">
                      Parsih is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label
                      className={
                        data.anniversary_date
                          ? "label-inline"
                          : "highlightField label-inline"
                      }
                    >
                      Anniversary Date (Month/Year)
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <DatePicker
                      required
                      autoComplete="off"
                      dateFormat="MM-dd-yyyy"
                      placeholderText="mm-dd-yyyy"
                      selected={data && data.anniversary_date}
                      onChange={(e) => handleDatePicker(e)}
                      className="form-control"
                      name="anniversary_date"
                      id="anniversary_date"
                      maxDate={new Date()}
                      showDisabledMonthNavigation
                      renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                      }) => {
                        const years = Array.from(
                          { length: 100 },
                          (_, i) => new Date().getFullYear() - i,
                        );
                        const months = [
                          "January",
                          "February",
                          "March",
                          "April",
                          "May",
                          "June",
                          "July",
                          "August",
                          "September",
                          "October",
                          "November",
                          "December",
                        ];

                        return (
                          <div
                            style={{
                              textAlign: "center",
                              paddingBottom: "8px",
                            }}
                          >
                            {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                            <div
                              style={{
                                marginBottom: "10px",
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              {/* Month Dropdown */}
                              <select
                                style={{
                                  fontSize: "16px",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                }}
                                value={months[date.getMonth()]}
                                onChange={({ target: { value } }) =>
                                  changeMonth(months.indexOf(value))
                                }
                              >
                                {months.map((month) => (
                                  <option key={month} value={month}>
                                    {month}
                                  </option>
                                ))}
                              </select>

                              {/* Year Dropdown */}
                              <select
                                style={{
                                  fontSize: "16px",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                }}
                                value={date.getFullYear()}
                                onChange={({ target: { value } }) =>
                                  changeYear(value)
                                }
                              >
                                {years.map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* ✅ Optional month navigation below */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                onClick={decreaseMonth}
                                disabled={prevMonthButtonDisabled}
                                style={{
                                  fontSize: "18px",
                                  padding: "2px 8px",
                                  cursor: "pointer",
                                }}
                              >
                                {"<"}
                              </button>

                              <span
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {months[date.getMonth()]} {date.getFullYear()}
                              </span>

                              <button
                                onClick={increaseMonth}
                                disabled={nextMonthButtonDisabled}
                                style={{
                                  fontSize: "18px",
                                  padding: "2px 8px",
                                  cursor: "pointer",
                                }}
                              >
                                {">"}
                              </button>
                            </div>
                          </div>
                        );
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Anniversary Date is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label>Notes</Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="notes"
                      id="notes"
                      placeholder="Notes"
                      value={data.notes}
                      onChange={(e) => handleChanges(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Notes is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label
                      className={data.allergies ? null : "highlightField"}
                    >
                      Do you or your spouse have any dietary allergies, dietary
                      restrictions or physical limitations?
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      required
                      size="sm"
                      type="text"
                      name="allergies"
                      id="allergies"
                      value={data.allergies}
                      onChange={(e) => handleChanges(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide dietary allergies, dietary restrictions, or
                      any physical limitations.
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                </section>

                <section className="rr-couple-section">
                  <div className="rr-couple-section-head">
                    <span className="rr-couple-section-icon" aria-hidden="true">
                      <Phone size={16} />
                    </span>
                    <div>
                      <h3>Emergency Contacts</h3>
                      <p>Add at least one person we can call if needed.</p>
                    </div>
                  </div>
                <div className="row">
                  <div className="rr-couple-subhead">Primary contact</div>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <Form.Label
                      className={data.emergency_name1 ? null : "highlightField"}
                    >
                      Emergency Name 1<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="emergency_name1"
                      id="emergency_name1"
                      placeholder="Name"
                      value={data.emergency_name1}
                      onChange={(e) => handleChanges(e)}
                    />
                  </Form.Group>

                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <Form.Label
                      className={
                        data.emergency_relationship1 ? null : "highlightField"
                      }
                    >
                      Emergency Relationship 1<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="emergency_relationship1"
                      id="emergency_relationship1"
                      placeholder="Relationship"
                      value={data.emergency_relationship1}
                      onChange={(e) => handleChanges(e)}
                    />
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <Form.Label
                      className={
                        data.emergency_phone1 ? null : "highlightField"
                      }
                    >
                      Emergency Phone 1<span className="text-danger">*</span>
                    </Form.Label>
                    <PhoneInput
                      name="emergency_phone1"
                      value={data.emergency_phone1}
                      onChange={(e) => handleChanges(e)}
                    />
                  </Form.Group>

                  <div className="rr-couple-subhead is-optional">
                    Second contact <span>Optional</span>
                  </div>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <Form.Label>Emergency Name 2</Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="emergency_name2"
                      id="emergency_name2"
                      placeholder="Name"
                      value={data.emergency_name2}
                      onChange={(e) => handleChanges(e)}
                    />
                  </Form.Group>

                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <Form.Label>Emergency Relationship 2</Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="emergency_relationship2"
                      id="emergency_relationship2"
                      placeholder="Relationship"
                      value={data.emergency_relationship2}
                      onChange={(e) => handleChanges(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Relationship is required!
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <Form.Label>Emergency Phone 2</Form.Label>
                    <PhoneInput
                      name="emergency_phone2"
                      value={data.emergency_phone2}
                      onChange={(e) => handleChanges(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Phone is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                </section>

                <section className="rr-couple-section">
                  <div className="rr-couple-section-head">
                    <span className="rr-couple-section-icon" aria-hidden="true">
                      <Megaphone size={16} />
                    </span>
                    <div>
                      <h3>How they found LoveStrong</h3>
                      <p>Optional. Choose every option that applies.</p>
                    </div>
                  </div>
                  <div className="rr-couple-chips">
                    <label className="rr-couple-chip">
                      <input
                        type="checkbox"
                        className="form-check-input ageLabel"
                        name="Website"
                        value="Website"
                        onChange={handleCheckboxChange}
                        checked={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes("Website")
                        }
                        disabled={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes(data.hear_us === "Website")
                        }
                      />
                      Website
                      <i className="input-helper"></i>
                    </label>

                    <label className="rr-couple-chip">
                      <input
                        type="checkbox"
                        className="form-check-input ageLabel"
                        name="Church Bulletin"
                        value="Church Bulletin"
                        onChange={handleCheckboxChange}
                        checked={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes("Church Bulletin")
                        }
                        disabled={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes(
                            data.hear_us === "Church Bulletin",
                          )
                        }
                      />
                      Church Bulletin
                      <i className="input-helper"></i>
                    </label>

                    <label className="rr-couple-chip">
                      <input
                        type="checkbox"
                        className="form-check-input ageLabel"
                        name="Facebook"
                        value="Facebook"
                        onChange={handleCheckboxChange}
                        checked={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes("Facebook")
                        }
                        disabled={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes(data.hear_us === "Facebook")
                        }
                      />
                      Facebook
                      <i className="input-helper"></i>
                    </label>

                    <label className="rr-couple-chip">
                      <input
                        type="checkbox"
                        className="form-check-input ageLabel"
                        name="School Marquee"
                        value="School Marquee"
                        onChange={handleCheckboxChange}
                        checked={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes("School Marquee")
                        }
                        disabled={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes(
                            data.hear_us === "School Marquee",
                          )
                        }
                      />
                      School Marquee
                      <i className="input-helper"></i>
                    </label>

                    <label className="rr-couple-chip">
                      <input
                        type="checkbox"
                        className="form-check-input ageLabel"
                        name="Pulpit Talk/Table in Church"
                        value="Pulpit Talk/Table in Church"
                        onChange={handleCheckboxChange}
                        checked={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes("Pulpit Talk/Table in Church")
                        }
                        disabled={
                          data &&
                          data.hear_us &&
                          data.hear_us.includes(
                            data.hear_us === "Pulpit Talk/Table in Church",
                          )
                        }
                      />
                      Pulpit Talk/Table in Church
                      <i className="input-helper"></i>
                    </label>
                  </div>
                  <Form.Group className="rr-couple-referral">
                    <Form.Label htmlFor="referral_from_a_friend_or_family_member">
                      Referral from a friend or family member
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="referral_from_a_friend_or_family_member"
                      placeholder="Name of the person who referred them"
                      id="referral_from_a_friend_or_family_member"
                      value={data.referral_from_a_friend_or_family_member}
                      className="form-control"
                      onChange={(e) => {
                        handleChanges(e);
                      }}
                    />
                  </Form.Group>
                </section>
                </div>
              </Modal.Body>
              <Modal.Footer className="rr-couple-footer">
                <p className="rr-couple-footer-note">
                  Fields marked with * are required.
                </p>
                <div className="rr-couple-footer-actions">
                  <Button
                    type="button"
                    variant="light"
                    className="rr-couple-btn rr-couple-btn--ghost"
                    onClick={() => {
                      CloseCompose();
                    }}
                  >
                    Cancel
                  </Button>
                  {userData && userData.userRole === "SUBADMIN" ? null : (
                    <Button
                      variant="primary"
                      type="submit"
                      className="rr-couple-btn rr-couple-btn--primary"
                    >
                      {editingCouple ? "Save Changes" : "Submit"}
                    </Button>
                  )}
                </div>
              </Modal.Footer>
            </Form>
          </Tab>
          <Tab eventKey="Retreats" title="Retreats">
            {renderCoupleRetreats()}
          </Tab>
        </Tabs>
          </div>
        </div>
      </Modal>
      <OtherParishModal
        show={otherParishModalOpen}
        handleClose={() => setOtherParishModalOpen(false)}
        registerationData={data}
        setRegisterationData={setData}
        setParishList={setParishList}
        parishList={parishList}
      />
    </>
  );
};

export default UpdateCouplePopUp;
